import { Button, ButtonFill, ButtonWidth, ComponentAlign, Container, DensitySpacing, FdsIcon, Icon, Orientation, Typography, TypographyVariant } from '@tcc/fds';
import FieldThumbnail from '../../../FieldThumbnail/FieldThumbnail';
import styles from '../RegionReport.css';
import { toDateString } from '../../../../utils/date';
import { Activity, GeoJson } from '../../../../types';

export type ThumbnailActivity = Pick<Activity, 'title' | 'color' | 'scoutedAt'>;

export type RegionThumbnailNoteBoxProps = {
  activity: ThumbnailActivity;
  geoJson: GeoJson;
  locale: string;
  fieldName: string;
  onRegionButtonClick: () => void;
  isClickable?: boolean;
  displayNoteButton?: boolean;
};

export const RegionThumbnailNoteBox = ({
  onRegionButtonClick,
  activity,
  geoJson,
  locale,
  fieldName,
  displayNoteButton = true,
}: RegionThumbnailNoteBoxProps) => (
  <Container
  testId="region-note-thumbnail-region-button"
  transparent
  orientation={Orientation.Horizontal}
  width='100%'
  align={ComponentAlign.Stretch}>
    <Container transparent orientation={Orientation.Horizontal} >
        <Container
          testId="region-note-box-field-thumbnail"
          transparent
          orientation={Orientation.Horizontal}
          width='fit-content'
          gap={DensitySpacing.Together}>
          <FieldThumbnail
            fillColor="#FFF"
            geoJson={geoJson}
            regionColor={activity.color}
            regionFillOpacity={0.2} />
        </Container>
        <Container
          transparent
          orientation={Orientation.Vertical}
          width='fit-content'
          justify={ComponentAlign.End}
          gap={DensitySpacing.Together}
          align={ComponentAlign.Start}
        >
          <Typography tag='h3' testId="region-note-box-field-thumbnail-field-name" variant={TypographyVariant.Label}>
            {fieldName}
          </Typography>
          {activity?.title &&
            <Typography tag='h4' variant={TypographyVariant.Label}>
              <time className={styles.thumbnailScoutedAt} data-test-id="region-note-box-region-scoutedAt">
                {toDateString(activity.scoutedAt, locale)}
              </time>
            </Typography>
          }
        </Container>
    </Container>
    <Container transparent orientation={Orientation.Horizontal} justify={ComponentAlign.End}>
      {displayNoteButton && (
        <Button
          testId="region-report-note-button"
          fill={ButtonFill.Outline}
          width={ButtonWidth.FitContent}
          onClick={onRegionButtonClick}>
          <Icon icon={FdsIcon.ContractEdit} />
          {activity?.title}
        </Button>
      )}
    </Container>
  </Container>
);
